import * as React from 'react';
import {NotificationContainer} from 'tt-components/src/Notifications';

export const NotificationComponent = () => (
  <div className="player-notifications-container">
    <NotificationContainer />
  </div>
);
